import { setAgeGroupInStorage } from "@/lib/age-group/store";
import { isAdultBirthYear } from "@/lib/utils/adult-age";

export function parseBirthYear(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === "") return null;
  const year = typeof value === "number" ? value : Number.parseInt(String(value).trim(), 10);
  if (!Number.isFinite(year) || !Number.isInteger(year)) return null;
  if (year < 1000 || year > 9999) return null;
  return year;
}

/**
 * Use a birth year only to mark kid/grownup. The year itself is never persisted.
 * Callers that need the year on the wire (contact form) should send it separately.
 *
 * Pass `{ notify: false }` to persist without broadcasting (e.g. under-18 contact
 * submit so the soft thank-you can render before ContactAccessGate redirects).
 */
export function markAgeGroupFromBirthYear(
  birthYear: string | number,
  opts?: { notify?: boolean }
): { birthYear: number; status: "adult" | "child" } | null {
  const year = parseBirthYear(birthYear);
  if (year === null) {
    console.warn("[birth-year] Ignoring invalid birth year", { birthYear });
    return null;
  }

  if (!isAdultBirthYear(year)) {
    setAgeGroupInStorage("kid", opts);
    return { birthYear: year, status: "child" };
  }

  setAgeGroupInStorage("grownup", opts);
  return { birthYear: year, status: "adult" };
}
